import { createReducer, on } from '@ngrx/store';
import { mediasActions } from '../actions/medias.actions';
import { MediaItem } from '../models';
import { PaginationParams } from '../types';

export interface MediasState {
    loaded: boolean | null;
    loading: boolean | null;
    items: MediaItem[];
    total: number;
    page: number;
    limit: number;
    lastParams: PaginationParams;
}

export const initialState: MediasState = {
    loaded: null,
    loading: null,
    items: [],
    total: 0,
    page: 1,
    limit: 20,
    lastParams: { page: 1, limit: 20 },
};

export const mediasReducer = createReducer(
    initialState,
    on(mediasActions.getMedia, (state, { value }): MediasState => ({
        ...state,
        loading: true,
        page: value.page,
        limit: value.limit,
        lastParams: value,
    })),
    on(mediasActions.getMediaSuccess, (state, { payload, total }): MediasState => ({
        ...state,
        loaded: true,
        loading: false,
        items: payload,
        total,
    })),
    on(mediasActions.getMediaError, (state): MediasState => ({
        ...state,
        loaded: false,
        loading: false,
    })),
    on(mediasActions.clear, (): MediasState => ({ ...initialState })),
);
